import { useState } from 'react';
import { Button, ToggleButton, ToggleButtonGroup, ToggleButtonGroupProps } from '@mui/material';

import { isLastArrayIndex } from 'src/utils/keysConverter';
import Box from 'src/components/Box';

import styles from './styles';

const TAGS_PER_PAGE = 20;

type ToggleTag = {
  id: number;
  name: string;
};

type ToggleTagGroupProps = ToggleButtonGroupProps & {
  tags: ToggleTag[];
  isDisabled?: boolean;
};

const ToggleTagGroup: React.FC<ToggleTagGroupProps> = props => {
  const { tags = [], isDisabled = false, size = 'small', value, onChange, ...restProps } = props;
  const [page, setPage] = useState<number>(1);

  const visibleTags = tags.slice(0, TAGS_PER_PAGE * page);
  const isShowMoreButton = visibleTags.length < tags.length;

  const renderMoreButton = () => {
    const tagsCountLeft = tags.length - visibleTags.length;
    const tagsMoreCount = tagsCountLeft < TAGS_PER_PAGE ? tagsCountLeft : TAGS_PER_PAGE;
    return (
      <Box key="more-button-wrapper">
        <Button sx={styles.moreButton} variant="outlined" onClick={() => setPage(prevPage => prevPage + 1)}>
          Show {tagsMoreCount} more...
        </Button>
      </Box>
    );
  };

  return (
    <ToggleButtonGroup value={value} size={size} onChange={onChange} {...restProps}>
      {visibleTags.map((tag, index, array) => {
        if (isShowMoreButton && isLastArrayIndex(index, array)) {
          return renderMoreButton();
        }
        return (
          <ToggleButton key={tag.id} value={tag.id} disabled={isDisabled}>
            {tag.name}
          </ToggleButton>
        );
      })}
    </ToggleButtonGroup>
  );
};

export default ToggleTagGroup;
